module.exports = __webpack_public_path__ + "img/P150T_weapon_73.3e9cab1c.png";